import React, { useState } from "react";
import Grid from "@mui/material/Grid";
import { menuSelect } from "../ComponentInterface";
import { getLastLogin, getURLparam, hasURLparam } from "../Url";
import smetaAxios from "../SmetaAxios";
import { AxiosRequestConfig } from "axios";
import { Prefixes } from "../MainPage/Tools/ProjectX";
import SignInEditor from "./signInTools/SignInEditor";
import { getEditorListFormat } from "../MainPage/Tools/Tools";

// const baseURL =
//   "http://localhost:1317/mobile~project/getconfiglist?LicGUID=ED16868F4BEF468AC4DF0F8CB0E75D4A&All=0&All=0 HTTP/1.1";

const SelectDrx = (props: menuSelect) => {
  let LastDrx = getLastLogin().split(",");

  const [drxconnect, setDrxServer] = useState([]);

  React.useEffect(() => {
    if (hasURLparam("configname")) {
      props.setBackInfo(getURLparam("configname"));
    }
  }, []);

  const getDrx = () => {
    const allConfigs = localStorage.getItem("allConfigs");
    const config: AxiosRequestConfig = {
      prefix: Prefixes.default,
      params: {
        all: Boolean(allConfigs) && 1,
      },
    };
    smetaAxios.get("getConfigList", config).then((res) => {
      setDrxServer(res);
    });
  };

  const OnKeyEnter = (e: any) => {
    if (e.keyCode === 13) {
      props.KeyDown(e);
    } else if (e.keyCode === 40) {
      getDrx();
    }
  };

  function MenuItems(drxList: any) {
    return getEditorListFormat(Object.values(drxList));
  }

  return (
    <Grid item xs>
      <SignInEditor
        label={"Конфигурация"}
        onKeyDown={OnKeyEnter}
        onPickListButtonClick={getDrx}
        items={MenuItems(drxconnect)}
        onEdit={props.setBackInfo}
        defaultValue={{
          label: hasURLparam("configname") ? getURLparam("configname") : LastDrx === undefined ? "" : LastDrx[0],
        }}
      />
    </Grid>
  );
};

export default SelectDrx;
